import { Button } from './Button'

function getPageNumbers(current, total) {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1)

  const pages = []
  const addPage = (p) => pages.push(p)
  const addEllipsis = () => pages.push('…')

  addPage(1)

  if (current <= 4) {
    // Near start: show 1-5, …, last
    for (let i = 2; i <= Math.min(5, total - 1); i++) addPage(i)
    addEllipsis()
  } else if (current >= total - 3) {
    // Near end: first, …, last 5
    addEllipsis()
    for (let i = Math.max(total - 4, 2); i <= total - 1; i++) addPage(i)
  } else {
    // Middle: first, …, current-1, current, current+1, …, last
    addEllipsis()
    addPage(current - 1)
    addPage(current)
    addPage(current + 1)
    addEllipsis()
  }

  addPage(total)
  return pages
}

export function Pagination({ currentPage, totalItems, pageSize, onPageChange, isDarkMode = false }) {
  const totalPages = Math.ceil(totalItems / pageSize)

  if (totalPages <= 1) return null

  const pages = getPageNumbers(currentPage, totalPages)

  const btnBase = 'min-w-[36px] px-3 py-2 rounded text-sm font-medium transition-colors duration-150'
  const activeBtn = 'bg-sfp-orange text-white'
  const inactiveBtn = isDarkMode
    ? 'bg-slate-700 text-slate-300 hover:bg-slate-600'
    : 'bg-sfp-lightgray text-sfp-darkgray hover:bg-sfp-border'
  const ellipsisBtn = isDarkMode ? 'text-slate-500 cursor-default' : 'text-gray-400 cursor-default'

  return (
    <div className="flex items-center justify-center gap-2 mt-6 py-4 flex-wrap">
      <Button
        variant="secondary"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        isDarkMode={isDarkMode}
      >
        Previous
      </Button>

      <div className="flex gap-1 flex-wrap justify-center">
        {pages.map((page, idx) =>
          page === '…' ? (
            <span key={`ellipsis-${idx}`} className={`${btnBase} ${ellipsisBtn} text-center`}>
              …
            </span>
          ) : (
            <button
              key={page}
              onClick={() => onPageChange(page)}
              className={`${btnBase} ${currentPage === page ? activeBtn : inactiveBtn}`}
            >
              {page}
            </button>
          )
        )}
      </div>

      <Button
        variant="secondary"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        isDarkMode={isDarkMode}
      >
        Next
      </Button>
    </div>
  )
}
